import React from 'react';
import PropTypes from 'prop-types';

function YooMoneyIcon({ className, w, h }) {
  return (
    <svg width={w} height={h} viewBox="0 0 86 18" className={className}>
      <g fill="none" fillRule="evenodd">
        <g fillRule="nonzero">
          <g>
            <g>
              <g>
                <path
                  fill="#8B3FFD"
                  d="M16.34 0c-5.01 0-8.995 4.044-8.995 9 0 5.013 4.042 9 8.996 9 4.953 0 8.995-4.044 8.995-9 .057-4.956-4.042-9-8.995-9zm0 12.36c-1.821 0-3.359-1.537-3.359-3.36s1.538-3.36 3.36-3.36C18.162 5.64 19.7 7.176 19.7 9s-1.48 3.36-3.36 3.36zM7.345 2.62L7.345 15.722 4.099 15.722 0 2.62z"
                  transform="translate(-2171 -645) translate(1569 630) translate(602 12) translate(0 3)"
                />
                <path
                  fill="#000"
                  d="M83.24 4.956l-1.993 4.898c-.057.057-.057.171-.057.228l-.057.114-.057-.114c0-.057-.057-.17-.057-.228l-1.993-4.898h-2.562l3.36 8.373-1.424 3.19h2.562l4.726-11.563H83.24zM64.337 5.411c-.456-.341-1.025-.57-1.708-.626-1.139-.114-2.22.285-2.96 1.025V4.9h-2.335v8.373h2.335V8.886c0-.968.17-1.253.341-1.48.285-.457.797-.684 1.424-.684.626 0 1.195.284 1.48.74.17.342.227.798.227 1.025v4.785h2.335v-5.07c0-1.31-.399-2.221-1.139-2.79zM52.893 5.013c-1.139-.4-2.391-.342-3.53.17-.74.342-1.423.912-1.822 1.652-.399.627-.57 1.425-.57 2.279 0 .854.171 1.652.57 2.278.399.627.911 1.197 1.594 1.538.683.342 1.48.57 2.22.57.4 0 .798-.057 1.196-.17.342-.115.684-.229 1.025-.4.684-.398 1.253-.911 1.595-1.538.398-.626.569-1.424.569-2.278.057-1.88-1.025-3.475-2.847-4.101zm.683 4.215c-.057.74-.284 1.367-.74 1.766-.341.285-.854.455-1.48.512-.626 0-1.082-.17-1.48-.512-.456-.4-.684-1.026-.74-1.766-.058-.855.284-1.538.91-1.994.342-.228.797-.399 1.253-.399.512 0 .91.171 1.31.4.683.398 1.024 1.138.967 1.993zM44.296 5.411c-.456-.341-1.025-.57-1.708-.626h-.399c-.91 0-1.708.399-2.391 1.196l-.114.17h-.228c-.17-.284-.398-.512-.626-.683-.456-.341-1.025-.57-1.708-.626-1.082-.114-1.936.228-2.676 1.025v-.854h-2.334v8.373h2.334v-4.5c0-.911.114-1.14.285-1.424.284-.456.797-.74 1.366-.684.57 0 1.082.285 1.367.741.227.342.227.74.227 1.14v4.67h2.335v-4.5c0-.854.113-1.14.284-1.424.285-.456.797-.683 1.367-.683s1.025.284 1.31.74c.17.285.227.627.227.854v4.956h2.334V8.146c0-.456-.057-.912-.17-1.31-.228-.57-.57-1.083-1.082-1.425zM74.244 10.766c-.342.342-1.139.968-2.22 1.025-.912.057-1.595-.228-2.107-.74-.228-.228-.399-.57-.512-.912h6.433v-.057c.057-.341.114-.626.114-.968 0-.285-.057-.684-.17-1.196-.286-.969-.855-1.71-1.595-2.279-.854-.626-1.651-.797-1.879-.797-1.65-.285-3.53.456-4.498 1.994-.683 1.082-.626 2.164-.626 2.506 0 .399.057 1.652 1.082 2.791 1.195 1.31 2.846 1.367 3.359 1.424 2.277.057 3.815-1.367 4.156-1.652l-1.537-1.14zm-3.986-3.532c.342-.228.74-.399 1.253-.399.512 0 .911.171 1.31.4.341.284.626.626.796 1.025h-4.099c.057-.4.342-.798.74-1.026z"
                  transform="translate(-2171 -645) translate(1569 630) translate(602 12) translate(0 3)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

YooMoneyIcon.propTypes = {
  w: PropTypes.number,
  h: PropTypes.number,
  className: PropTypes.string,
};

YooMoneyIcon.defaultProps = {
  w: 86,
  h: 18,
};

export default YooMoneyIcon;
